import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ErpTravelManagementNotesValue } from '../../../shared/model/travelmanagement-values';
import { FurtherDetails } from '../../model/furtherdetails';
@Component( {
    selector: 'erp-businesstripapplication-further-details',
    templateUrl: './businesstripapplication-further-details.component.html'
} )
export class BusinesstripApplicationFurtherDetailsComponent {
    @Input() furtherDetails: FurtherDetails = new FurtherDetails();
    @Output() readonly furtherDetailsChange: EventEmitter<FurtherDetails> = new EventEmitter<FurtherDetails>();
    constructor() { }

    onModelChange( changedValue: number | boolean ) {
        this.furtherDetailsChange.emit( this.furtherDetails );
    }
}
